import { render, staticRenderFns } from "./ContactFrame.vue?vue&type=template&id=5848b967&scoped=true&"
import script from "./ContactFrame.vue?vue&type=script&lang=js&"
export * from "./ContactFrame.vue?vue&type=script&lang=js&"
import style0 from "./ContactFrame.vue?vue&type=style&index=0&id=5848b967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848b967",
  null
  
)

export default component.exports